<template>
    <BaseBtn v-on="$listeners" :icon="getIcon" :label="$t('label')" :id="id" />
</template>

<script>
import BaseBtn from './BaseBtn'

export default {
    name: 'KeyResultToggleListDropdownBtn',
    components: {
        BaseBtn,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        isOpen: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    computed: {
        getIcon() {
            return this.isOpen ? 'angle-up' : 'angle-down'
        },
    },
    i18n: {
        messages: {
            'en-US': {
                label: 'Key results',
            },
            'es-ES': {
                label: 'Resultados clave',
            },
            'pt-BR': {
                label: 'Resultados chave',
            },
        },
    },
}
</script>
